<div class="d-flex fd-col full-height pl-24 pr-24 overflow-y-auto custom-scrollbar" tabindex="0">

  <div class="d-flex fd-col mb-32 mt-24">

    <div class="d-flex fd-row justify-space-between full-height gap-16 indicators-row">
      <!-- Vehicles -->
      <div class="chart-container full-height d-flex align-items-center justify-content-center indicator-box"
        matTooltip="Vehículos" matTooltipPosition="above" matTooltipClass="custom-tooltip">
        <div class="d-flex fd-row align-items-center indicator-content">
          <sit-icon [icon]="Icon.vehicle_blue" [sizeClass]="'icon-size-32'" alt="icono vehiculos"></sit-icon>
          <div class="d-flex fd-col text-white indicator-value">
            <span class="text-weight-600 text-size-24">{{ vehicleCount }}</span>
          </div>
        </div>
      </div>

      <!-- Motorcycles -->
      <div class="chart-container full-height d-flex align-items-center justify-content-center indicator-box"
        matTooltip="Motocicletas" matTooltipPosition="above" matTooltipClass="custom-tooltip">
        <div class="d-flex fd-row align-items-center indicator-content">
          <sit-icon [icon]="Icon.motorcycle_blue" [sizeClass]="'icon-size-32'" alt="icono motocicletas"></sit-icon>
          <div class="d-flex fd-col text-white indicator-value">
            <span class="text-weight-600 text-size-24">{{ motorcycleCount }}</span>
          </div>
        </div>
      </div>

      <!-- Pedestrians -->
      <div class="chart-container full-height d-flex align-items-center justify-content-center indicator-box"
        matTooltip="Peatones" matTooltipPosition="above" matTooltipClass="custom-tooltip">
        <div class="d-flex fd-row align-items-center indicator-content">
          <sit-icon [icon]="Icon.pedestrian_blue" [sizeClass]="'icon-size-32'" alt="icono peatones"></sit-icon>
          <div class="d-flex fd-col text-white indicator-value">
            <span class="text-weight-600 text-size-24">{{ pedestrianCount }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Search Input -->
    <div class="search-container full-width mt-16 mb-16 relative">
      <input type="text" class="search-input text-color-white" placeholder=" " [value]="searchText"
        (input)="onSearchInput($event)" (focus)="onFocus()" (blur)="onBlur()">
      <label class="floating-label">Buscar</label>

      <!-- Search Icon (Right) - Hide if focused or has text -->
      <sit-icon *ngIf="!searchText && !isSearchFocused" [icon]="Icon.search_w" [sizeClass]="'icon-size-24'"
        class="search-icon-right"></sit-icon>

      <!-- Clear Icon (Right) - Show if focused or has text -->
      <sit-icon *ngIf="searchText || isSearchFocused" [icon]="Icon.close_x" [sizeClass]="'icon-size-16'"
        class="clear-icon" (click)="clearSearch()"></sit-icon>
    </div>

    <!-- Camera Status Row - Removed mt-16 to balance spacing -->
    <div class="d-flex fd-row justify-space-between full-height gap-16 indicators-row">


      <!-- install Cameras (Blue) -->
      <div class="chart-container full-height d-flex align-items-center justify-content-center indicator-box"
        matTooltip="Puntos De Aforo Instalados" matTooltipPosition="above" matTooltipClass="custom-tooltip">
        <div class="d-flex fd-row align-items-center indicator-content">
          <sit-icon [icon]="Icon.camera_monitoring_blue" [sizeClass]="'icon-size-48'"
            alt="cámaras mantenimiento"></sit-icon>
          <div class="d-flex fd-col text-white indicator-value">
            <span class="text-weight-600 text-size-24">{{ cameraCount }}</span>
          </div>
        </div>
      </div>

      <!-- Active Cameras (Green) -->
      <div class="chart-container full-height d-flex align-items-center justify-content-center indicator-box"
        matTooltip="Puntos De Aforo Activos" matTooltipPosition="above" matTooltipClass="custom-tooltip">
        <div class="d-flex fd-row align-items-center indicator-content">
          <sit-icon [icon]="Icon.camera_monitoring_green" [sizeClass]="'icon-size-32'" alt="cámaras activas"></sit-icon>
          <div class="d-flex fd-col text-white indicator-value">
            <span class="text-weight-600 text-size-24">{{ activeCameraCount }}</span>
          </div>
        </div>
      </div>


      <!-- Inactive Cameras (Red) -->
      <div class="chart-container full-height d-flex align-items-center justify-content-center indicator-box"
        matTooltip="Puntos De Aforo Inactivos" matTooltipPosition="above" matTooltipClass="custom-tooltip">
        <div class="d-flex fd-row align-items-center indicator-content">
          <sit-icon [icon]="Icon.camera_monitoring_red" [sizeClass]="'icon-size-32'" alt="cámaras inactivas"></sit-icon>
          <div class="d-flex fd-col text-white indicator-value">
            <span class="text-weight-600 text-size-24">{{ inactiveCameraCount }}</span>
          </div>
        </div>
      </div>

    </div>
  </div>



  <div class="aforo-cards-container">
    <div *ngFor="let card of card_list " class="aforo-card" (click)="openModal(card)">
      <h4 class="aforo-card-title text-color-primary-1">{{card.cameraName}}</h4>
      <span class="aforo-card-subtitle text-color-white">
        <sit-icon class="pl-md-10-pt dp-flex mr-05-em" [icon]="Icon.schedule_y" [sizeClass]="'icon-size-22'"></sit-icon>
        {{card.date}}
      </span>
      <!--<div class="aforo-card-indicator">
        <div class="indi left text-color-secondary-1">
          <h4 class="text-weight-600">{{card.speedAverage.toFixed(2) || '00' }} Km/h</h4>
          <span class="text-color-white">Velocidad promedio</span>
        </div>
        <div class="indi right text-color-secondary-1">
          <h4 class="text-weight-600"> {{card.count || '0'}} </h4>
          <span class="text-color-white">Conteo total</span>
        </div>

      </div>-->

    </div>
  </div>
</div>